import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Container,
  Grid,
  Pagination,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PeopleIcon from "@mui/icons-material/People";
import ScienceIcon from "@mui/icons-material/Science";
import StarsIcon from "@mui/icons-material/Stars";
import StorageIcon from "@mui/icons-material/Storage";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { htmlToSlate } from "../../utils";
import { getFullApiUrl } from "../../config";
import Header from "../Header";
import { LoadingPage } from "../LoadingPage";
import { ErrorPage } from "../ErrorPage";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PodcasterEpisodesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [podcastData, setPodcastData] = useState(null);
  const [videoData, setVideoData] = useState({
    videos: [],
    numberOfEpisodes: 0,
  });
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [videoPage, setVideoPage] = useState(1);
  const podcastId = location.state.podcastId;

  const getAudioStatus = (audioStatus) => {
    if (audioStatus === "processing") {
      return { label: "正在处理音频", color: "warning" };
    }
    if (audioStatus === "failed") {
      return { label: "音频处理失败，点击重新上传", color: "error" };
    }
    return null;
  };

  const getPublicationStatus = (publishedAt) => {
    if (!publishedAt) {
      return { status: "草稿", color: "default", type: "draft" };
    }
    
    const publishDate = new Date(publishedAt);
    const now = new Date();
    
    if (publishDate <= now) {
      return { status: "已发布", color: "success", type: "published" };
    } else {
      return { status: "定时发布", color: "warning", type: "scheduled" };
    }
  };

  const formatPublishDate = (publishedAt) => {
    if (!publishedAt) return null;
    
    const publishDate = new Date(publishedAt);
    const now = new Date();
    
    if (publishDate > now) {
      return `将于 ${publishDate.toLocaleString()} 发布`;
    }
    return publishDate.toLocaleString();
  };

  useEffect(() => {
    console.log(`tabValue: ${tabValue}`);
    const fetchData = async () => {
      try {
        setLoading(true);
        if (tabValue === 0) {
          const response = await axios.get(
            getFullApiUrl("/api/v1/podcaster/episodes"),
            {
              params: {
                start: (page - 1) * 10,
                end: page * 10,
                podcast: podcastId,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );

          setPodcastData({
            podcast: JSON.parse(response.data.podcast),
            episodes: JSON.parse(response.data.episodes),
            numberOfEpisodes: response.data.number_of_episodes,
          });
        } else if (tabValue === 1) {
          const videoResponse = await axios.get(
            getFullApiUrl("/api/v1/subscribe/get_videos"),
            {
              params: {
                podcast: podcastId,
                start: (videoPage - 1) * 10,
                end: videoPage * 10,
              },
            }
          );
          setVideoData(videoResponse.data);
          console.log(videoResponse.data);
        }
      } catch (err) {
        console.error("Error fetching RSS data:", err);
        setError("Failed to load podcast data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [page, videoPage, podcastId, tabValue]);

  // 有正在处理音频的单集时，定时静默刷新列表以更新处理状态
  useEffect(() => {
    if (tabValue !== 0 || !podcastData) {
      return;
    }
    const hasProcessing = podcastData.episodes.some(
      (episode) => episode.AudioStatus === "processing"
    );
    if (!hasProcessing) {
      return;
    }

    const timer = setInterval(async () => {
      try {
        const response = await axios.get(
          getFullApiUrl("/api/v1/podcaster/episodes"),
          {
            params: {
              start: (page - 1) * 10,
              end: page * 10,
              podcast: podcastId,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        setPodcastData({
          podcast: JSON.parse(response.data.podcast),
          episodes: JSON.parse(response.data.episodes),
          numberOfEpisodes: response.data.number_of_episodes,
        });
      } catch (err) {
        console.error("Error refreshing episodes:", err);
      }
    }, 10000);

    return () => clearInterval(timer);
  }, [tabValue, podcastData, page, podcastId]);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  const handlePageChange = async (event, value) => {
    setPage(value);
  };

  const handleVideoPageChange = async (event, value) => {
    setVideoPage(value);
  };

  const handleVideoCardClick = (item) => {
    console.log(item);
    navigate(`/podcaster/video-editor/${podcastId}/${item.ID}`);
  };

  const handleCardClick = (item) => {
    console.log(item);
    console.log(htmlToSlate(item.Content));
    navigate(`/podcaster/editor/${podcastId}/${item.ID}?type=episode`);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    console.log(`newValue: ${newValue}`);
  };

  const VideoTab = () => {
    return (
      <>
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(`/podcaster/video-editor/${podcastId}/new`);
            }}
            startIcon={<AddIcon />}
          >
            创建新视频
          </Button>
          {videoData &&
            Array.from(videoData.videos).map((item, index) => (
              <Grid item xs={12} key={index}>
                <CardActionArea onClick={() => handleVideoCardClick(item)}>
                  <Card sx={{ display: "flex", height: "30%" }} elevation={3}>
                    <CardContent sx={{ flex: 1 }}>
                      <Typography component="h2" variant="h5">
                        {item.Title || "No title"}
                      </Typography>
                      <Typography variant="subtitle1" color="text.secondary">
                        {new Date(item.PublishedAt).toLocaleString()}
                      </Typography>
                    </CardContent>
                  </Card>
                </CardActionArea>
              </Grid>
            ))}
        </Grid>
        <Pagination
          sx={{ mt: 5 }}
          count={Math.ceil((videoData.number_of_videos || 0) / 10)}
          page={videoPage}
          onChange={handleVideoPageChange}
        />
      </>
    );
  };

  const PodcastTab = () => {
    return (
      <>
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(`/podcaster/editor/${podcastId}/new?type=episode`);
            }}
            startIcon={<AddIcon />}
          >
            创建新播客
          </Button>
          {podcastData &&
            Array.from(podcastData.episodes).map((item, index) => {
              const pubStatus = getPublicationStatus(item.PublishedAt);
              const pubDate = formatPublishDate(item.PublishedAt);
              const audioStatus = getAudioStatus(item.AudioStatus);

              return (
                <Grid item xs={12} key={index}>
                  <CardActionArea onClick={() => handleCardClick(item)}>
                    <Card sx={{ display: "flex", height: "30%" }} elevation={3}>
                      <CardContent sx={{ flex: 1 }}>
                        <Box
                          sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}
                        >
                          <Typography component="h2" variant="h5" sx={{ mr: 2 }}>
                            {item.Title || "No title"}
                          </Typography>
                          {/* mt 让 24px 高的 chip 与 h5 首行(行高约 32px)垂直居中 */}
                          <Chip
                            label={pubStatus.status}
                            color={pubStatus.color}
                            size="small"
                            sx={{ mt: "4px", flexShrink: 0 }}
                          />
                          {audioStatus && (
                            <Chip
                              label={audioStatus.label}
                              color={audioStatus.color}
                              size="small"
                              sx={{ ml: 1, mt: "4px", flexShrink: 0 }}
                            />
                          )}
                        </Box>
                        <Typography variant="subtitle1" color="text.secondary">
                          {pubDate || "未设置发布时间"}
                        </Typography>
                      </CardContent>
                    </Card>
                  </CardActionArea>
                </Grid>
              );
            })}
        </Grid>
        <Pagination
          sx={{ mt: 5 }}
          count={Math.ceil((podcastData.numberOfEpisodes || 0) / 10)}
          page={page}
          onChange={handlePageChange}
        />
      </>
    );
  };

  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      maxWidth="md"
    >
      <Header podcast={podcastData.podcast} />

      <Box sx={{ mt: 2, mb: 2 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            navigate("/podcaster/user_management");
          }}
          startIcon={<PeopleIcon />}
        >
          用户管理
        </Button>
        <Button
          variant="outlined"
          color="primary"
          sx={{ ml: 2 }}
          onClick={() => {
            navigate("/podcaster/test_account");
          }}
          startIcon={<ScienceIcon />}
        >
          测试账号
        </Button>
        <Button
          variant="outlined"
          color="primary"
          sx={{ ml: 2 }}
          onClick={() => {
            navigate("/podcaster/zsxq_management");
          }}
          startIcon={<StarsIcon />}
        >
          知识星球
        </Button>
        <Button
          variant="outlined"
          color="primary"
          sx={{ ml: 2 }}
          onClick={() => {
            navigate("/podcaster/sql");
          }}
          startIcon={<StorageIcon />}
        >
          SQL 控制台
        </Button>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="basic tabs example"
        >
          <Tab label="播客" {...a11yProps(0)} />
          <Tab label="视频" {...a11yProps(1)} />
        </Tabs>
      </Box>
      {tabValue === 0 && <PodcastTab podcastData={podcastData} />}
      {tabValue === 1 && <VideoTab videoData={videoData} />}
    </Container>
  );
};

export default PodcasterEpisodesPage;
